import { render, staticRenderFns } from "./baisc-info.vue?vue&type=template&id=589120bc&scoped=true"
import script from "./baisc-info.vue?vue&type=script&lang=js"
export * from "./baisc-info.vue?vue&type=script&lang=js"
import style0 from "./baisc-info.vue?vue&type=style&index=0&id=589120bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589120bc",
  null
  
)

export default component.exports